import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRetweet } from '@fortawesome/free-solid-svg-icons';

/** Compact repost glyph + label (parent usually owns the clickable chrome). */
const RepostButton = ({ onClick, size = 16, count = 0, active = false }) => {
  const label =
    count > 0 ? `Repost · ${count}` : 'Repost';

  return (
    <div
      onClick={onClick}
      style={{
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '6px',
        fontSize: size,
        color: active ? '#0a66c2' : 'inherit',
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        userSelect: 'none',
        lineHeight: 1,
      }}
    >
      <FontAwesomeIcon icon={faRetweet} aria-hidden />
      <span className="post-action-text" style={{ fontSize: 15, fontWeight: 600 }}>
        {label}
      </span>
    </div>
  );
};

export default RepostButton;
